import { inject, Injectable, OnDestroy } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { BehaviorSubject, Subject ,skip, distinctUntilChanged, filter } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
 
@Injectable({
  providedIn: 'root',
})
export class LayoutService implements OnDestroy {

  private destroy$ = new Subject<void>();

  private _breakpointObserver = inject(BreakpointObserver);
  private _inMobile$ = new BehaviorSubject<boolean>(false);
  private _inTablet$ = new BehaviorSubject<boolean>(false);
  private _inDesktop$ = new BehaviorSubject<boolean>(false);

  readonly inMobile$ = this._inMobile$.asObservable();
  readonly inTablet$ = this._inTablet$.asObservable();
  readonly inDesktop$ = this._inDesktop$.asObservable();

  readonly mobileToDesktop$ = this._inMobile$.asObservable().pipe(
    skip(1),                        
    distinctUntilChanged(),         
    filter(isMobile => !isMobile)   
  );
  
  inMobile = false;
  inTablet = false;
  inDesktop = true;
  
  MOBILE = '(max-width: 600px)';
  TABLET = '(min-width: 601px) and (max-width: 1024px)';
  DESKTOP = '(min-width: 1025px)';
 
  constructor() {
    this.listenBreakpoints();
  }
  ngOnDestroy(): void {
    this.destroy$.next(); 
    this.destroy$.complete();
  }
 
  private listenBreakpoints() {
    this._breakpointObserver
      .observe([this.MOBILE])
      .pipe(takeUntil(this.destroy$))
      .subscribe((breakPointState) => {
        this._inMobile$.next(breakPointState.matches);
        this.inMobile = breakPointState.matches;
      });
 
    this._breakpointObserver
      .observe([this.TABLET])
      .pipe(takeUntil(this.destroy$))
      .subscribe((breakPointState) => {
        this._inTablet$.next(breakPointState.matches);
        this.inTablet = breakPointState.matches;
      });
 
    this._breakpointObserver
      .observe([this.DESKTOP])
      .pipe(takeUntil(this.destroy$))
      .subscribe((breakPointState) => {
        this._inDesktop$.next(breakPointState.matches);
        this.inDesktop = breakPointState.matches;
      });
  }
}